import { render, staticRenderFns } from "./tipsDialog.vue?vue&type=template&id=3bf6ac20&scoped=true"
import script from "./tipsDialog.vue?vue&type=script&lang=js"
export * from "./tipsDialog.vue?vue&type=script&lang=js"
import style0 from "./tipsDialog.vue?vue&type=style&index=0&id=3bf6ac20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6ac20",
  null
  
)

export default component.exports